import { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { errMsg, fmtDate } from "@/lib/api";

export function SlotPicker({ loadSlots, book, onBooked, title = "Scegli una nuova data", emptyText, extra }) {
  const [slots, setSlots] = useState(null);
  const [day, setDay] = useState(null);
  const [time, setTime] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => loadSlots()
    .then((data) => { setSlots(data); setDay(data[0]?.date || null); setTime(null); })
    .catch((err) => setError(errMsg(err)));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const book_ = async () => {
    setBusy(true);
    setError("");
    try {
      const label = await book(day, time);
      onBooked(label);
    } catch (err) {
      setError(errMsg(err));
      load();
    } finally {
      setBusy(false);
    }
  };

  if (!slots && !error) return <div className="h-24 animate-pulse rounded-2xl bg-slate-100" />;
  const current = slots?.find((s) => s.date === day);

  return (
    <div className="space-y-4 border-t border-[#e2e8f0] pt-5" data-testid="slot-picker">
      <div>
        <h2 className="text-lg font-bold">{title}</h2>
        <p className="text-sm text-slate-500">Orari liberi nel calendario della dottoressa.</p>
      </div>
      {error && <div className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="slot-picker-error">{error}</div>}
      {slots && slots.length === 0 && (
        <p className="rounded-xl bg-slate-50 p-4 text-sm text-slate-600" data-testid="slot-picker-empty">{emptyText || "Al momento non ci sono orari liberi prenotabili online. Rispondi all'email del promemoria per concordare una nuova data."}</p>
      )}
      {slots && slots.length > 0 && (
        <>
          <div className="flex gap-2 overflow-x-auto pb-1">
            {slots.map((s) => (
              <button key={s.date} onClick={() => { setDay(s.date); setTime(null); }} data-testid={`slot-day-${s.date}`}
                className={`shrink-0 rounded-2xl border px-3 py-2 text-center transition-colors ${day === s.date ? "border-[#3d655b] bg-[#3d655b] text-white" : "border-[#e2e8f0] bg-white hover:border-[#b8956f]"}`}>
                <div className="text-[10px] font-semibold uppercase">{fmtDate(s.date, { weekday: "short" })}</div>
                <div className="text-lg font-extrabold leading-tight">{fmtDate(s.date, { day: "2-digit" })}</div>
                <div className="text-[10px]">{fmtDate(s.date, { month: "short" })}</div>
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
            {current?.times.map((t) => (
              <button key={t} onClick={() => setTime(t)} data-testid={`slot-time-${t}`}
                className={`rounded-full border py-2 text-sm font-semibold transition-colors ${time === t ? "border-[#3d655b] bg-[#edf2ef] text-[#2f4f47]" : "border-[#e2e8f0] hover:border-[#b8956f]"}`}>{t}</button>
            ))}
          </div>
          {extra}
          <button className="btn-primary w-full" disabled={!time || busy} onClick={book_} data-testid="slot-book-button">
            <CalendarCheck className="h-4 w-4" /> {busy ? "Prenotazione…" : time ? `Prenota ${fmtDate(day, { day: "numeric", month: "long" })} alle ${time}` : "Seleziona un orario"}
          </button>
        </>
      )}
    </div>
  );
}
